var map = {
	"./estado-1/estado-1.svg": 82588,
	"./estado-10/estado-10.svg": 70434,
	"./estado-11/estado-11.svg": 122,
	"./estado-12/estado-12.svg": 99286,
	"./estado-13/estado-13.svg": 58790,
	"./estado-14/estado-14.svg": 77090,
	"./estado-15/estado-15.svg": 51594,
	"./estado-16/estado-16.svg": 44846,
	"./estado-17/estado-17.svg": 23822,
	"./estado-18/estado-18.svg": 71906,
	"./estado-19/estado-19.svg": 9386,
	"./estado-2/estado-2.svg": 442,
	"./estado-20/estado-20.svg": 55330,
	"./estado-21/estado-21.svg": 14946,
	"./estado-22/estado-22.svg": 98730,
	"./estado-23/estado-23.svg": 34458,
	"./estado-24/estado-24.svg": 78810,
	"./estado-25/estado-25.svg": 51338,
	"./estado-26/estado-26.svg": 20610,
	"./estado-27/estado-27.svg": 1954,
	"./estado-28/estado-28.svg": 84066,
	"./estado-29/estado-29.svg": 75938,
	"./estado-3/estado-3.svg": 37884,
	"./estado-30/estado-30.svg": 90410,
	"./estado-31/estado-31.svg": 14486,
	"./estado-32/estado-32.svg": 46206,
	"./estado-4/estado-4.svg": 52598,
	"./estado-5/estado-5.svg": 43084,
	"./estado-6/estado-6.svg": 74594,
	"./estado-7/estado-7.svg": 17452,
	"./estado-8/estado-8.svg": 29590,
	"./estado-9/estado-9.svg": 748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97060;